import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import './style.css'

import { toast } from "react-toastify";
import { useDispatch, useSelector } from 'react-redux'
import { register, getUsers, editUser } from '../../../../pages/features/users/userSlice'

// import { ResourceData } from './resources.data'
import { TableHeader } from '../../../../components/tableheader'
// import { TableData } from '../../../../components/tabledata'
import { TableData } from './tabledata'

import { Button } from '../../../../components/button'
import Spinner from '../../../../components/spinner';

const Users = () => {
    const [addResource, setAddResource] = useState(false)
    const [userFirstName, setUserFirstName] = useState('')
    const [userLastName, setUserLastName] = useState('')
    const [userEmail, setUserEmail] = useState('')
    const [userPassword, setUserPassword] = useState('')

    const [searchTerm, setSearchTerm] = useState('')

    const [updateUIWithout, setUpdateUIWithout] = useState(''); //Update UI after deleting
    const [canEdit, setCanEdit] = useState('') //Edit resourceCategory state

  

    const {user, userStatus, isLoading, isError, isSuccess, message } = useSelector(state => state.user);
    const [usersState, setUsersState] = useState(user || [''])

    const dispatch = useDispatch();

    

    const handleAddResource = (e) => {
      if(canEdit){
        setCanEdit('')
        setAddResource(false)
        setUserFirstName('')
        setUserLastName('')
        setUserEmail('')
        setUserPassword('')
       } else {
        setAddResource(!addResource)
       }

    }

    //updateUI without
    useEffect(()=> {
      setUsersState([...usersState.filter((user) => user.userId !== updateUIWithout)])
    }, [updateUIWithout])



//     useEffect(() => {
      
      
//       dispatch(reset());

//   }, [user, isError, isSuccess, message, dispatch]);

  useEffect(() => {
    dispatch(getUsers());
}, [userStatus]);


  const onSubmit = (data) => {
      data.preventDefault();

      // 
        {
          const userData = {
              userFirstName,
              userLastName,
              userEmail,
              userPassword
          }

          if(canEdit){
            dispatch(editUser({...userData, userId: canEdit}))
            const indexOfEdited = usersState.indexOf(usersState.find((user) => user.userId === canEdit))
    
            // const editedCategory = resourceCategoriesState.splice(indexOfEdited, 1)
    
            //Replace old edited category with updated
            usersState.splice(indexOfEdited, 1, userData)
    
            setUsersState(usersState)
            // console.log(resourceCategoriesState)
            // setResourceCategoriesState()
    
            setCanEdit('')
    
    
          } else {
            dispatch(register(userData))
          }

          
          
        }

  };

  //searchTerm state watcher
  useEffect(()=> {
    setUsersState([...usersState.filter((user) => user?.userFirstName?.toLowerCase().includes(searchTerm.toLowerCase()) || user?.userLastName?.toLowerCase().includes(searchTerm.toLowerCase()) || user?.userEmail?.toLowerCase().includes(searchTerm.toLowerCase()))])

  }, [searchTerm])

  //canEdit state watcher
  useEffect(()=> {
    if(canEdit){
      // alert("You can edit now")
      setAddResource(true)

      const cateogoryToEdit = usersState.filter((user) => user.userId === canEdit)[0]

      setUserFirstName(cateogoryToEdit['userFirstName'])
      setUserLastName(cateogoryToEdit['userLastName'])
      setUserEmail(cateogoryToEdit['userEmail'])
      setUserPassword(cateogoryToEdit['userPassword'])

    }
  }, [canEdit])

  
// handlers
const onSearchTextInput = (e) => {
    setSearchTerm(e.target.value)
}

  if (isLoading) {
      return <Spinner />; 
  }


  return (
    <Container className='body_cont'>
      
      <PageHeader>
        <h2>User Details</h2>
        
        <div className='search_bar'>
          <input type="text" name='searchUser' id='searchUser'  placeholder='Search User' value={searchTerm} onChange={onSearchTextInput} />
          <div onClick={handleAddResource} >
          <Button filled bgColor={'#2A870E'} text={canEdit || addResource ? 'Cancel' : ' + Add'} noIcon reverse />
          </div>
          
        </div>
      </PageHeader>

{addResource ?
      <AddResource>

        <form onSubmit= {onSubmit}> 

        <MainForm>
            <div>
              <label htmlFor="firstName">First name</label>
              <input 
                name='userFirstName' 
                value={userFirstName} 
                type="text" 
                placeholder='First Name'
                onChange={(e) =>setUserFirstName(e.target.value) }
                id='userFirstName'
                autoComplete='off'
                
              />
            </div>

            <div>
              <label htmlFor="lastName">Last name</label>
              <input 
                name='userLastName' 
                value={userLastName} 
                type="text" 
                placeholder='Last Name'
                onChange={(e) =>setUserLastName(e.target.value) } 
                id='userLastName'
                autoComplete='off'
              
              />
            </div>

            <div>
              <label htmlFor="userEmail">Email</label>
              <input 
                name='userEmail' 
                value={userEmail}  
                type="email" 
                id='userEmail'
                placeholder='Enter your email' 
                onChange={(e) =>setUserEmail(e.target.value) } 
                autoComplete='off'

              />
            </div>


            <div>
              <label htmlFor="userPassword">Password</label>
              <input 
                name='userpassword' 
                value={userPassword} 
                type="password" 
                id='userpassword'
                placeholder='Create a password'
                onChange={(e) =>{setUserPassword(e.target.value);} } 
              />
            </div>


        
        </MainForm>

        <div className='publish'>
          <Button filled bgColor={'#2A870E'} text={'Publish'} noIcon reverse />
        </div>
        
        </form>
        
      </AddResource>
:
null
}

      <section>
        <TableHeader resourceTitle={'First name'} authorName={'Last name'} resourceUrl={'Email'} />
         
        { usersState.length > 0 ? (
          
          <>
          
           {
              usersState?.map((users) => {
                // console.log(users)
                return (

                  // <TableData key={tag._id} tag={tag} />'
                  
                <TableData user={users} key={users?.userId} 
                resourceTitle={users?.userFirstName?.substring(0, 50) + '...'} 
                authorName={users?.userLastName?.substring(0, 50) + '...'}
                userEmail={users?.userEmail?.substring(0, 50) + '...'}
                // userIsVerified={users?.userIsVerified?.substring(0, 50) + '...'} 
                setUpdateUIWithout={setUpdateUIWithout} setCanEdit={setCanEdit}
                />               
                  )
                })
            }    
          
          </>

         ) : ( <h4>You have no user</h4> )

         }
</section>

      

      
    </Container>
  )
}

const Container = styled.section`
  padding-top: 40px;
  padding-left: 30px;
  padding-right: 30px;
  width: 100%;
`

const PageHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  & > div{
    display: flex;
    height: 40px;

    & > input{
      /* outline: none; */
      padding: 1rem;
      background-color: inherit;
      border-radius: 4px;
      border: 1px solid #D0D5DD;
    }

    & button{
      padding: 1rem;
      margin-left: 1rem;
      /* width: 50px; */
    }
  }
`

const AddResource = styled.div`
  padding: 0px 25px 0;
  border: 1px solid #D0D5DD;
  margin-top: 30px;
  margin-bottom: 30px;

  & form {


    & > :last-child{
      margin-top: 3rem;
      border-top: 1px solid #D0D5DD;
      align-self: flex-end;
      padding: 1rem 0;
    }
    & button{
      padding: 1rem;
      margin-left: 1rem;
      align-self: flex-end;
      
    }
  }
`



const MainForm = styled.div`


  & > div{

    display: flex;
    flex-direction: column;
    width: 100%;

    & > input{
      background-color: inherit;
      height: 44px;
      padding: 1rem;
      border-radius: 4px;
      border: 1px solid #D0D5DD;
      width: 100%;
      
  }

    & > label{
      font-size: 14px;
      font-weight: 500;
      margin-top: 25px;
      margin-bottom: 0.8rem;
      /* color: #667085; */
    }

    & > textarea{
      height: 10rem;
      padding: 1rem;
      border-radius: 4px;
      border: 1px solid #D0D5DD;
      background-color: #fff;

    }

    
  }
`

const DividedInput = styled.section`
 

  & > div{
    display: flex;
    flex-direction: column;
    

    

  &  label{
      font-size: 14px;
      font-weight: 500;
      margin-top: 10px;
      margin-bottom: 5px;

    }

  }
`

export {Users}